import {
    APP_INITIALIZER,
    EnvironmentProviders,
    makeEnvironmentProviders,
    Provider,
} from '@angular/core';
import { CustomerConfigService } from '@core/configs/customer-config.service';
import { SearchConfigService } from '@core/configs/search-config.service';
import { SystemConfigService } from '@core/configs/system-config.service';

const providers: Provider[] = [
    {
        provide: APP_INITIALIZER,
        useFactory: (systemConfigService: SystemConfigService) => {
            return () => systemConfigService.loadSystemConfig();
        },
        deps: [SystemConfigService],
        multi: true,
    },
    {
        provide: SearchConfigService,
        useFactory: (systemConfigService: SystemConfigService) => {
            return new SearchConfigService(systemConfigService);
        },
        deps: [SystemConfigService],
    },
    {
        provide: CustomerConfigService,
        useFactory: (systemConfigService: SystemConfigService) => {
            return new CustomerConfigService(systemConfigService);
        },
        deps: [SystemConfigService],
    },
];

/**
 * Provide system config
 *
 * @export
 * @return {*}  {EnvironmentProviders}
 */
export default function provideSystemConfig(): EnvironmentProviders {
    return makeEnvironmentProviders(providers);
}
